import GestureIcon from '@mui/icons-material/Gesture';
import UploadIcon from '@mui/icons-material/Upload';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import FilePresent from '@mui/icons-material/FilePresent';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useRef, useState } from "react";
import ReactSignatureCanvas from "react-signature-canvas";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

export const CreateSignature = ({ open, objectToSign, setSignature, onClose }) => {
    const signatureRef = useRef(null);
    const fileInputRef = useRef(null);
    const [valueTab, setValueTab] = useState(0);
    const OnChengeSetValue = (event, newTab) => setValueTab(newTab);
    const CleanSingnature = () => signatureRef.current.clear();
    const handleFileClick = () => fileInputRef.current.click();

    const SaveSingnature = () => {
        if (signatureRef?.current && !signatureRef?.current.isEmpty()) {
            const canvas = signatureRef.current.getCanvas();
            const resizedCanvas = document.createElement('canvas');
            const context = resizedCanvas.getContext('2d');
            const width = 220;
            const height = 60;
            resizedCanvas.width = width;
            resizedCanvas.height = height;
            context.drawImage(canvas, 0, 0, width, height);
            const signatureImg = resizedCanvas.toDataURL('image/png');//Debe ser png
            setSignature({ img: signatureImg, id_signature: objectToSign.id_signature, order: objectToSign.order });
        }
        else if (imagePreview) {
            setSignature({ img: imagePreview, id_signature: objectToSign.id_signature, order: objectToSign.order });
        }
        else
            alert('Debe dibujar o seleccionar una imagen');
    };

    const [imagePreview, setImagePreview] = useState(null);
    const [imageName, setImageName] = useState(null);
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImageName(file.name);
            const reader = new FileReader();
            reader.onload = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='sm'
            PaperProps={{
                style: { height: '90%' },
            }}
        >
            <DialogTitle>
                <Typography variant='h5' component='h5'>
                    Firmar documento
                </Typography>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex' }}>
                    <Tabs
                        value={valueTab}
                        onChange={OnChengeSetValue}
                    >
                        <Tab
                            icon={<GestureIcon color='success' />}
                            iconPosition="start"
                            label='Dibujar firma'
                        />
                        <Tab
                            icon={<UploadIcon color='info' />}
                            iconPosition="start"
                            label='Cargar firma'
                        />
                    </Tabs>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ marginTop: 2 }}>
                    <Grid size={{ xs: 12}}>
                        <TextField
                            aria-readonly
                            fullWidth
                            label='Nombre completo'
                            InputLabelProps={{ shrink: true }}
                            size='small'
                            variant='outlined'
                            name='name'
                            value={'Jose L Diaz'}
                        />
                    </Grid>
                </Box>

                <Box
                    spacing={1}
                    sx={{ mt: 2 }}
                >
                    <TabPanel value={valueTab} index={0}>
                        <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Link
                                onClick={CleanSingnature}
                                sx={{
                                    right: 15,
                                    cursor: 'pointer'
                                }}
                            >
                                Limpiar
                            </Link>
                        </Grid>
                        <ReactSignatureCanvas
                            ref={signatureRef}
                            penColor="black"
                            canvasProps={{
                                width: 540,
                                height: 120,
                                className: 'firma-canvas'
                            }}
                        />
                    </TabPanel>
                    <TabPanel value={valueTab} index={1}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm:4, md:6 }}>
                                <FormGroup
                                    style={{ height: '30px', display: 'flex' }}
                                >
                                    <TextField
                                        name='fileToSing'
                                        size="small"
                                        fullWidth
                                        type="text"
                                        label="Seleccione..."
                                        required
                                        InputLabelProps={{ shrink: true }}
                                        aria-readonly={true}
                                        value={imageName}
                                        InputProps={{
                                            endAdornment: (
                                                <Tooltip title={'Seleccionar archivo'}>
                                                    <FilePresent style={{ fontSize: 25, color: 'gray' }} />
                                                </Tooltip>
                                            ),
                                        }}
                                        onClick={handleFileClick}
                                    />
                                    <input
                                        accept="image/png"
                                        style={{ display: 'none' }}
                                        id="raised-button-file"
                                        type="file"
                                        ref={fileInputRef}
                                        onChange={handleImageChange}
                                    />
                                </FormGroup>
                                <Typography
                                    sx={{
                                        mt: 2,
                                        fontSize: 11,
                                        textAlign: 'justify',
                                        display: 'block'
                                    }}
                                    component={'span'}
                                >
                                    Tenga en cuenta que la imagen que seleccione representara si firma; Esta debe ser .png, tener fondo blanco y medidas aproximadas a 180 * 50 pixeles.
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, sm:4, md:6 }}>
                                {
                                    imagePreview ?
                                        <Box
                                            sx={{
                                                position: "relative",
                                                width: '265px',
                                                height: '90px',
                                                margin: "0 auto",
                                                textAlign: "center"
                                            }}
                                        >
                                            <img
                                                src={imagePreview}
                                                alt="Vista previa"
                                                style={{
                                                    height: "auto",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "8px"
                                                }}
                                            />
                                        </Box>
                                        :
                                        <Typography>
                                            Cargue una imagen para ver la vista previa aqui
                                        </Typography>
                                }
                            </Grid>
                        </Grid>
                    </TabPanel>
                </Box>
                <Box
                    sx={{ mt: 2 }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 'bold',
                            marginRight: '8px'
                        }}
                    >
                        Al seleccionar Adoptar y firmar, acepto que la firma es la representación electrónica de mi firma a todos los efectos cuando yo (o mi agente) las utilicemos en documentos, incluidos los contratos legalmente vinculados
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mt: 2
                    }}
                >
                    <Button
                        onClick={onClose}
                        variant='contained'
                        color='primary'
                        sx={{ mx: 3 }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant='contained'
                        color='success'
                        onClick={SaveSingnature}
                    >
                        Aplicar firma
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};